import React from 'react';
import { monthsFullWord } from '../../../../../utils/MonthYear/monthYear';

interface ChartInputEditFieldsProps {
  dataSet: (number | undefined)[] | undefined;
  onInputChange: (_value: number, _index: number) => void;
  isNumbersValid: boolean;
}
export const ChartInputEditFields: React.FC<ChartInputEditFieldsProps> = ({
  dataSet,
  onInputChange,
  isNumbersValid,
}) => {
  return (
    <div className="flex ps-[5vh] py-1">
      <div className="flex flex-1  justify-around  ">
        {dataSet?.map((data, index) => (
          <input
            key={index}
            title={`Edit ${monthsFullWord[index]} `}
            type="number"
            value={data || 0}
            onChange={(e) => {
              console.log(e.target.value);
              e.target.value && onInputChange(parseInt(e.target.value), index);
            }}
            className={`min-w-[2rem] max-w-[3rem] text-sm  w-full h-[2rem]
                hide-spin-sm-md show-spin-lg-xl
                 border-1 border-${isNumbersValid ? 'gray-300' : 'red'} border-opacity-50 text-center rounded ${
              !data && 'text-gray-450'
            } `}
          />
        ))}
      </div>
    </div>
  );
};
